<template>
  <div>
    <PageHeader title="جزییات مدیریت سفارشات" :items="pageHeaderItems" />
    <div class="card px-4 py-3">
      <div class="order-detail">
        <div v-b-toggle.collapse-1 class="order-header" @click="orderArrowUp = !orderArrowUp">
          <div class="header">اطلاعات اولیه سفارش</div>
          <i :class="`fas fa-chevron-${orderArrowUp ? 'down' : 'up'}`"></i>
        </div>
        <b-collapse id="collapse-1" class="collapse-content" visible>
          <div class="right">
            <div class="right-titles">نام کاربر :</div>
            <div class="right-titles">شماره سفارش :</div>
            <div class="right-titles">مبلغ کل دوره :</div>
            <div class="right-titles">شماره موبایل کاربر :</div>
          </div>
          <div class="left">
            <div class="left-titles">{{ detail.fullName }}</div>
            <div class="left-titles">{{ detail.orderNumber || 'ــــــ' }}</div>
            <div class="left-titles price">{{ Commafy(detail.totalPrice) }}</div>
            <div class="left-titles">{{ detail.phoneNumber }}</div>
          </div>
        </b-collapse>
      </div>
    </div>
    <div class="card px-4 py-3">
      <div class="order-detail">
        <div v-b-toggle.collapse-2 class="order-header" @click="productArrowUp = !productArrowUp">
          <div class="header">اطلاعات مرسوله</div>
          <i :class="`fas fa-chevron-${productArrowUp ? 'down' : 'up'}`"></i>
        </div>
        <b-collapse id="collapse-2" visible>
          <div v-for="(item, index) in detail.orderItems" :key="index" class="products">
            <b-row>
              <b-col cols="12" md="3" class="image">
                <img :src="item.image" />
              </b-col>
              <b-col cols="12" md="8" class="contents">
                <div class="content-title">{{ item.title }}</div>
                <div class="tag">
                  <div class="tag-title">کد درس :</div>
                  <div class="tag-info">{{ item.productId }}</div>
                </div>
                <div class="tag">
                  <div class="tag-title">نوع :</div>
                  <div class="tag-info">{{ item.typeOfProduct }}</div>
                </div>
                <div class="d-flex">
                  <div class="tag">
                    <div class="tag-title">قیمت قبل تخفیف :</div>
                    <div class="tag-info price">{{ $route.query.isInstallment === 'True' ? Commafy(+item.totalPrice) : Commafy(+item.price + +item.discount) }}</div>
                  </div>
                  <div class="tag">
                    <div class="tag-title">قیمت بعد تخفیف :</div>
                    <div class="tag-info price">{{ Commafy(item.price) }}</div>
                  </div>
                  <div class="tag">
                    <div class="tag-title">قیمت کل :</div>
                    <div class="tag-info price" style="color: #556ee6">{{ Commafy(item.price) }}</div>
                  </div>
                </div>
              </b-col>
            </b-row>
            <div v-if="index > 0" class="line"></div>
          </div>
        </b-collapse>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from '../layoutComponents/page-header.vue'
import axios from 'axios'
import { API_URL } from '../../../config/HTTP'

export default {
  components: { PageHeader },
  data() {
    return {
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'جزییات مدیریت سفارشات', active: true },
      ],
      detail: {},
      orderArrowUp: false,
      productArrowUp: false,
    }
  },
  async created() {
    const req = await axios.post(API_URL + '/BizSchool/api/Basket/AdminOrderItem', {
      id: +this.$route.params.id,
      isInstallment: this.$route.query.isInstallment === 'True' ? true : false,
    })
    this.detail = req.data.data.output
  },
  methods: {
    Commafy(number) {
      if (number) {
        let floated = parseFloat(number)
        var str = floated.toString().split('.')
        if (str[0].length > 0) {
          str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1.')
          return str.join('.')
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.order-detail {
  border: 1px solid #f0f1f1;
  border-radius: 5px;
}
.order-header {
  display: flex;
  justify-content: space-between;
  padding: 10px 8px;
  position: relative;
  background: #f8f9fa;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.0520833);
  cursor: pointer;

  i {
    font-size: 10px;
    position: absolute;
    top: 15px;
    left: 24px;
    color: #555555;
  }
}
.header {
  font-weight: 500;
  font-size: 14px;
  line-height: 23px;
  color: #444444;
}

.right {
  width: 150px;
  display: inline-block;
}

.right-titles {
  font-weight: 400;
  font-size: 13px;
  line-height: 21px;
  text-align: right;
  color: #495057;
  margin: 20px;
}

.left {
  display: inline-block;
}

.left-titles {
  margin: 20px;
  font-weight: 500;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #555555;
  position: relative;
  top: 5px;
}

.image {
  margin: 20px;
  img {
    width: 100%;
    height: 192px;
    border-radius: 5px;
  }
}

.content-title {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  color: #4a4a4a;
  margin-bottom: 24px;
}

.tag {
  display: flex;
  margin-bottom: 20px;
  margin-left: 4%;
  .tag-title {
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    color: #979797;
  }
  .tag-info {
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    color: #4a4a4a;
    margin-right: 10px;
  }
}

.contents {
  margin: 20px -20px 20px 10px;
}

.price {
  &::after {
    content: 'تومان';
    margin-right: 5px;
    font-size: 13px;
    font-weight: 100;
  }
}

.line {
  height: 1px;
  background: #ced4da;
  margin: 0 20px;
  display: block !important;
}
</style>
